import { render, staticRenderFns } from "./coupon-opened-lottery-new.vue?vue&type=template&id=3ce9f05c&scoped=true&lang=pug&"
import script from "./coupon-opened-lottery-new.vue?vue&type=script&lang=js&"
export * from "./coupon-opened-lottery-new.vue?vue&type=script&lang=js&"
import style0 from "./coupon-opened-lottery-new.vue?vue&type=style&index=0&id=3ce9f05c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce9f05c",
  null
  
)

export default component.exports